import PackageGroup from '@/common/models/package-groups/PackageGroup';

import actions from './actions';
import mutations from './mutations';

const packageGroupsState: Record<number, PackageGroup> = {};
export default {
  state: packageGroupsState,
  mutations,
  actions,
};
